import {
  info,
  questionApi,
  collectionsPostApi,
  collectionsDeleteApi,
  upAnswersApi,
} from './service';
import { Effect } from 'umi';
import { Reducer } from '@@/plugin-dva/connect';
import { goBack } from '@/utils/bridge';

export interface questionType {
  data: topicType[];
  title: string;
  desc: string;
  part_hide: number;
  exam_id: number;
  duration: number;
  paper_id: string;
  parts: {
    id: number;
    title: string;
    content: string;
    is_hiden: number;
    count: number;
    question_ids: {
      question_id: string;
      part_id: number;
      score: number;
      id: number;
    }[];
  }[];
  countDown: number;
  topicTypeIndex: number[];
}

export interface ModelType {
  namespace: string;
  state: questionType;
  effects: {
    fetch: Effect;
    fetchQuestion: Effect;
    fetchCollections: Effect;
    fetchUpAnswer: Effect;
  };
  reducers: {
    save: Reducer;
    saveChange: Reducer;
    fetchAnswersChange: Reducer;
    collectionChange: Reducer;
    defaultData: Reducer;
  };
}

export interface topicType {
  part_id: number;
  analyzing: string;
  answers: string[];
  collected: boolean;
  diff_level: string;
  id: number;
  record?: {
    answers: string[];
    correct?: number;
  };
  options: {
    id: number;
    question_id: string;
    option: string;
    content: string;
    is_right: number;
  }[];
  question_id: string;
  score: number;
  tags: string;
  title: string;
  type: number;
  material_id?: string;
  material?: {
    content: string;
    id: number;
    key_words: string;
  };
  checked?: boolean;
  answersChecked: string[];
}

const Model: ModelType = {
  namespace: 'question',

  state: {
    data: [],
    exam_id: 0,
    title: '',
    desc: '',
    paper_id: '',
    part_hide: 0,
    parts: [],
    duration: 0,
    countDown: 0,
    topicTypeIndex: [],
  },

  effects: {
    *fetch({ payload, callback }, { call, put }) {
      const response = yield call(info, payload);
      if (response && response.error_code === 0) {
        let data: string | any[] = [];
        let arr: number[] = [];
        let topicTypeIndex: any = [];
        let questionIndex = 0;
        const paper = response.data.paper;

        // console.log(response.data.paper)
        paper.parts.forEach((item: any, index: number) => {
          if (item.question_ids.length > 0) {
            data = data.concat(item.question_ids);
            arr.push(item.question_ids.length);
          }
        });
        arr.reduce((sum, number) => {
          topicTypeIndex.push(sum);
          return sum + number;
        }, 0);

        if (data.length > 0 && response.data.last_question_id) {
          data.forEach((item, index) => {
            if (item.question_id === response.data.last_question_id) {
              questionIndex = index;
            }
          });
        }
        if (response.data.question_records) {
          data = data.map((item, index) => {
            let obj = {
              ...item,
            };
            response.data.question_records.forEach((value: any, index: any) => {
              if (value.question_id === item.question_id) {
                obj.record = {
                  answers: JSON.parse(value.answers),
                };
              }
            });
            return obj;
          });
        }
        yield put({
          type: 'save',
          payload: {
            ...response,
            questionData: data,
            topicTypeIndex,
          },
        });
        if (callback)
          callback({
            ...response,
            questionIndex,
          });
      } else if (
        response &&
        response.error_code > 0 &&
        response &&
        response.error_code < 1007
      ) {
        goBack();
      }
    },
    *fetchQuestion({ payload }, { call, put }) {
      const response = yield call(questionApi, payload);
      yield put({
        type: 'saveChange',
        payload: {
          ...response,
          index: payload.questionIndex,
        },
      });
    },
    *fetchCollections({ payload }, { call, put }) {
      const response = yield call(
        payload.isDel ? collectionsDeleteApi : collectionsPostApi,
        payload,
      );
      if (response && response.error_code === 0) {
        yield put({
          type: 'collectionChange',
          payload: {
            ...response,
            index: payload.questionIndex,
            isDel: payload.isDel,
          },
        });
      }
    },
    *fetchUpAnswer({ callback, payload }, { call, put }) {
      const response = yield call(upAnswersApi, payload);
      if (callback) callback(response);
    },
  },
  reducers: {
    save(state, { payload }) {
      const paper = payload.data.paper;
      let countDown =
        Date.now() + (paper.duration - payload.data.exam.duration) * 1000;

      if (paper.duration - payload.data.exam.duration === 0) {
        countDown = Date.now() + 5 * 1000;
      }
      return {
        ...state,
        data: payload.questionData,
        exam_id: payload.data.exam.id,
        parts: paper.parts,
        title: paper.title,
        paper_id: paper.paper_id,
        duration: paper.duration,
        countDown: countDown,
        topicTypeIndex: payload.topicTypeIndex,
      };
    },

    saveChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index;
      data[dataIndex - 1] = {
        ...data[dataIndex - 1],
        ...payload.data,
      };
      if (dataIndex - 2 > 0) {
        data[dataIndex - 3] = {
          question_id: data[dataIndex - 3].question_id,
          part_id: data[dataIndex - 3].part_id,
          score: data[dataIndex - 3].score,
          id: data[dataIndex - 3].id,
          record: {
            ...data[dataIndex - 3].record,
          },
          type: data[dataIndex - 3].type,
        };
      }
      if (dataIndex + 2 >= payload.length) {
        data[dataIndex + 2] = {
          question_id: data[dataIndex + 3].question_id,
          part_id: data[dataIndex + 3].part_id,
          score: data[dataIndex + 3].score,
          id: data[dataIndex + 3].id,
          record: {
            ...data[dataIndex + 3].record,
          },
          type: data[dataIndex + 3].type,
        };
      }
      return {
        ...state,
        data: data,
      };
    },

    fetchAnswersChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index - 1;
      let answers;
      if (payload.isCheckbox) {
        const indexData = data[dataIndex];
        if (
          indexData.hasOwnProperty('record') &&
          indexData.record.hasOwnProperty('answers')
        ) {
          const answersArr = indexData.record.answers;
          if (answersArr.indexOf(payload.answer) > -1) {
            answersArr.splice(answersArr.indexOf(payload.answer), 1);
            answers = answersArr;
          } else {
            answers = [...answersArr, payload.answer];
          }
        } else {
          answers = [payload.answer];
        }
      } else {
        answers = [payload.answer];
      }

      data[dataIndex] = {
        ...data[dataIndex],
        record: {
          ...data[dataIndex].record,
          answers: answers,
        },
      };
      return {
        ...state,
        data: data,
      };
    },

    collectionChange(state, { payload }) {
      const data: any = [...state.data];
      const dataIndex = payload.index - 1;
      data[dataIndex].collected = !payload.isDel;
      return {
        ...state,
        data: data,
      };
    },

    defaultData(state, { payload }) {
      return {
        ...state,
        data: [],
        exam_id: 0,
        title: '',
        desc: '',
        paper_id: '',
        part_hide: 0,
        parts: [],
        duration: 0,
      };
    },
  },
};

export default Model;
